import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconEnvelopeFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconEnvelopeFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '582a7356e867884800e39c73a1f2638dfe7d702f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6de9fd80baa86f609923db3ba001660c154b593d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '13c98088620b051d6bdbedcafe300979dabc7d33', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5v13a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-17a.5.5 0 0 0-.5.5m9 7.046L3.5 5.6v1.9l6.728 5.347a1.25 1.25 0 0 0 1.544 0L18.5 7.5V5.6z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-envelope-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-envelope-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-envelope-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconEnvelopeFilled$1);
            }
            break;
    } });
}

const CosmosIconEnvelopeFilled = CosmosIconEnvelopeFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconEnvelopeFilled, defineCustomElement };
